const SET_NOTIFICATION = '@new-releases/set-notification';

export { SET_NOTIFICATION };
